import React from 'react'
import './Document.css'
import PropTypes from 'prop-types'
import moment from 'moment'
//Bootstrap
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
function DocumentDetails(props) {
  const { targetedDocument } = props

  let value = targetedDocument.receivers.map((receiver, index) => `${index + 1}. ${receiver.name}`).join('\n')
  return (
    <Form>
      <Form.Group as={Row} controlId='formTo'>
        <Form.Label column sm='2' lg='2' md='2'>
          To:
        </Form.Label>
        <Col lg={true} md={true} sm={true}>
          <Form.Control
            as='textarea'
            readOnly
            rows={targetedDocument.totalReceivers > 3 ? 3 : targetedDocument.totalReceivers + 1}
            value={value}
          />
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId='formFrom'>
        <Form.Label column sm='2' lg='2' md='2'>
          From:
        </Form.Label>
        <Col lg={true} md={true} sm={true}>
          <Form.Control readOnly value={targetedDocument.sender.name} />
        </Col>
      </Form.Group>

      <Form.Group as={Row} controlId='formTitle'>
        <Form.Label column sm='2' lg='2' md='2'>
          Title:
        </Form.Label>
        <Col sm={true} lg={true} md={true}>
          <Form.Control readOnly value={targetedDocument.title} />
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId='formInfo'>
        <Form.Label column sm='2' lg='2' md='2'>
          Info
        </Form.Label>
        <Col sm={true} lg={true} md={true}>
          <Form.Control readOnly as='textarea' rows='3' value={targetedDocument.info} />
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId='formStatus'>
        <Form.Label column sm='2' lg='2' md='2'>
          Status:
        </Form.Label>
        <Col sm={true} lg={true} md={true}>
          <Form.Control readOnly value={targetedDocument.status} />
        </Col>
      </Form.Group>
      {targetedDocument.rejectReason && (
        <Form.Group as={Row} controlId='formInfo'>
          <Form.Label column sm='2' lg='2' md='2'>
            Reason:
          </Form.Label>
          <Col sm={true} lg={true} md={true}>
            <Form.Control readOnly as='textarea' rows='3' value={targetedDocument.rejectReason} />
          </Col>
        </Form.Group>
      )}
      <Form.Group as={Row} controlId='formCreated at'>
        <Form.Label column lg='2' sm='2' md='2'>
          Created at:
        </Form.Label>
        <Col sm={true} lg={true} md={true}>
          <Form.Control readOnly value={moment(targetedDocument.createdAt).format('LL')} />
        </Col>
      </Form.Group>
      <Form.Group as={Row} controlId='formDue Date'>
        <Form.Label column lg='2' sm='2' md='2'>
          Duedate:
        </Form.Label>
        <Col sm={true} lg={true} md={true}>
          <Form.Control
            readOnly
            value={`${moment(targetedDocument.dueDate).format('LL')}  (${moment(targetedDocument.dueDate).fromNow()})`}
          />
        </Col>
      </Form.Group>
    </Form>
  )
}

DocumentDetails.propTypes = {
  targetedDocument: PropTypes.object.isRequired,
}

export default DocumentDetails
